<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;">
        <el-tab-pane :label="$t('CargoMsg.Cargo_PaymentRequestBusiness')" name="billPaymentList">
          <bill-payment-list :show-wht="true" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import billPaymentList from '@/views/cargo/v0/Clearing/components/BillPaymentByJob/billPaymentList'

export default {
  name: 'BillPaymentByJob',
  components: {
    billPaymentList // 平台版付款申请查询列表
  },
  data() {
    return {
      activeTabName: 'billPaymentList'
    }
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss">
</style>
